/**
 * Hook returning the number of past weeks the current user still has to
 * validate. Used by:
 *   - the sidebar badge on the "Mon Espace" tab,
 *   - the badge on the "Congés" toggle inside Mon Espace.
 *
 * Backed by the same /api/leave/weeks/unvalidated/me endpoint as the
 * UnvalidatedWeeksPanel — sharing the same React Query key means the
 * cache is shared and clearing a week elsewhere immediately drops the
 * badge.
 */

import { useQuery } from '@tanstack/react-query';
import { leaveAPI } from '../api/leave.api';

export const useUnvalidatedWeeksCount = () => {
  const { data = [] } = useQuery({
    queryKey: ['leave', 'weeks-unvalidated', 'current'],
    queryFn: () => leaveAPI.myUnvalidatedWeeks(),
    staleTime: 60_000,
    // No socket event backs this badge, so without a fallback a newly-due
    // week only appeared after a full page reload. Refetch on focus and on a
    // low-frequency poll (the count only changes ~weekly). Clearing a week
    // still drops the badge instantly via the shared query cache.
    refetchOnWindowFocus: true,
    refetchInterval: 300_000,
  });
  return { count: data.length };
};
